<script lang="ts" setup>
    import { useBoost } from '@/helpers/composables/searchSpringApi';
    import { computed, type PropType, inject  } from 'vue';
    import { useSettingsStore } from '@/store/settings';
    import { storeToRefs } from 'pinia';
    import productVariantSwatches from '@/helpers/composables/productVariantSwatches';
    import { useFavoritesStore } from '@/store/favorites';
    import ProductCard from '@/components/ProductCard.vue';
    import HeroBanner from '@/components/HeroBanner.vue';
    let props = defineProps({
        boost_tag: {
            type: String,
            required: false
        },
    })

    let route = inject("route");
    let settings = useSettingsStore();
    let { user, is_dealer } = storeToRefs(settings);
    let products = computed(()=>{
        if (typeof window === "undefined") {
            return [];
        }
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('products')?.split?.(',') ?? [];
    });

 

    let boostTags = computed(()=>{
        if(props.boost_tag){
            return [props.boost_tag, "no-results"]
        }
        return ["no-results"]
    })
    let { productVariants, numberOfColors } = productVariantSwatches();
   
       let response = useBoost({
        tags: boostTags.value,
        products: products.value,
        shopperId: user.value.user_id ?? undefined,
        limit: 14
    }).response;

    let favoritesStore = useFavoritesStore();
    let { favorites } = storeToRefs(favoritesStore);
    let favoriteIds = computed(()=>{
        return favorites.value.map((favorite) => favorite.item_index);
    })

    let computedBoostedData = computed(()=>{
        let length = response.value?.length ?? 0
        return response.value?.length > 0 ? response.value.find(item => {
            if(props.boost_tag && item.profile.tag == props.boost_tag && item.results.length > 0){
                return true
            }
            return item.profile.tag == "no-results"
            
        })?.results.map((result, index) =>{
            let variants = productVariants(result.attributes.variants);
            if(Array.isArray(variants)){
                // flatten variatns 1 level
                variants = variants.reduce((acc, val) => acc.concat(val), []).map((variant)=>{
                    return JSON.parse(variant);
                });
            }
            return {
                numberOfColors: numberOfColors(variants),
                productImages: [{ image: result.mappings.core.imageUrl }],
                title: result.mappings.core.name,
                url: result.mappings.core.url ? route("productDetail.show", [result.mappings.core.url]) : route('404'),
                price: result.mappings.core.price,
                rating: result.mappings.core.rating,
                reviewCount: result.mappings.core.ratingCount,
                seo_name: result.mappings.core.url,
                variants: variants,
                isFavorite: favoriteIds.value.find(item => item == result.mappings.core.uid) != undefined,
                product_id: result.mappings.core.uid,
                fill_incomplete_row: (index+1) >= (length- (length% 7) + 1) && (index+1) <= (length)
            }
           
        }) : [];
    })
            


    let bannerProps = computed(()=>{
        return {
            banner_media: {
                min_height: 200,
                bg_color: 'None',
            },
            banner_content: {
                text_bg_color: 'None',
                content_align_vertical: 'middle',
                content_align_horizontal: 'center'
            },
            eyebrow: {
                text: '',
                color: 'rothcoBlack'
            },
            heading: {
                text: `Explore our products`,
                color: 'rothcoBlack'
            }
        }
    })
</script>

<template>
    <div>
        <HeroBanner v-bind="bannerProps" class="plp-category-header" />
        <div class="plp">
            <div class="container-filter-product-grid">
                <div class="product-grid-container">
                    <div class="product-grid">
                        <product-card
                            v-for="(product, index) in computedBoostedData"
                            :key="index"
                            :product-card-details="product"
                            allow-quick-view
                            :class="{
                                'fill-incomplete-row': product.fill_incomplete_row
                            }"
                            />
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
